import React from 'react';
import compose from 'recompose/compose';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import {
    EditButton,
    translate,
} from 'react-admin';
import { withStyles } from '@material-ui/core/styles';
import isEmpty from 'lodash/isEmpty';

import TrueValueField from '../TrueValueField';
import NameField from '../NameField';
import {isAdmin, isEditor} from '../permissions';

const listStyles = theme => ({
    card: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        margin: '0.5rem 0',
    },
    cardTitleContent: {
        display: 'flex',
        flexDirection: 'rows',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    cardContent: theme.typography.body1,
    cardContentRow: {
        display: 'flex',
        flexDirection: 'rows',
        alignItems: 'center',
        margin: '0.5rem 0',
    },
});

export const MobileGrid = ({permissions, classes, ids, data, basePath, translate}) => (
    <div style={{ margin: '1em' }}>
        {ids.map(id => (
            <Card key={id} className={classes.card}>
                <CardHeader
                    title={
                        <div className={classes.cardTitleContent}>
                            <span>
                                <NameField name={ !isEmpty(data[id].name) ? data[id].name : data[id].nameDE } />
                            </span>
                            {
                                (isAdmin(permissions) || isEditor(permissions)) &&
                                <EditButton
                                    resource="sport"
                                    basePath={basePath}
                                    record={data[id]}
                                />
                            }
                        </div>
                    }
                />
                <CardContent className={classes.cardContent}>

                    <TrueValueField className={classes.cardContentRow} label={translate('resources.sport.fields.id')} record={data[id]}  source="id" />

                    <TrueValueField className={classes.cardContentRow} label={translate('resources.sport.fields.name')} record={data[id]}  source="name" />

                    <TrueValueField className={classes.cardContentRow} label={translate('resources.sport.fields.nameDE')} record={data[id]}  source="nameDE" />

                    <TrueValueField className={classes.cardContentRow} label={translate('resources.sport.fields.isActive')} record={data[id]}  source="isActive" />

                    <TrueValueField className={classes.cardContentRow} label={translate('resources.sport.fields.sort')} record={data[id]}  source="sort" />

                    <TrueValueField className={classes.cardContentRow} label={translate('resources.sport.fields.sportGroupId')} record={data[id]}  source="sportGroupId" />

                </CardContent>

            </Card>
        ))}
    </div>
);

const enhance = compose(
    withStyles(listStyles),
    translate
);

export default enhance(MobileGrid);